
<div class="row g-3">
        <div class="col-sm-6 col-lg-3 g-3">
        <kpi-card
            title="Statut"
            [body]="{value: project?.status}"
            [footer]="{prefix: 'Clôture estimée: ', value: project?.estimatedCloseDate?.toLocaleDateString() || 'Non renseigné'}"
            [isLoading]="!project"
            class="h-100"></kpi-card>
    </div>
    <div class="col-sm-6 col-lg-3 g-3">
        <kpi-card
            title="Montant vendu"
            [body]="{value: project?.soldAmount || 0, suffix: '€ HT'}"
            [badge]="{value: project?.soldDayRate || 0, suffix: '€ HT / jours', style: 'info'}"
            [footer]="{prefix: 'Dont sous-traitance: ', value: project?.subcontractingAmount || 0, suffix: ' € HT'}"
            [isLoading]="!project"
            class="h-100"></kpi-card>
    </div>
    <div class="col-sm-6 col-lg-3 g-3">
        <kpi-card
            title="Jours vendus"
            [body]="{value: project?.daysSold || 0, suffix: ' jours'}"
            [badge]="{value: project?.daysRemaining || 0, suffix: ' restants', style: (project?.daysRemaining || 0) < 0 ? 'danger' : 'success' }"
            [footer]="{ value: project?.daysDeclared || 0, suffix: ' jours déclarés'}"
            [isLoading]="!project"
            class="h-100"></kpi-card>
    </div>
    <div class="col-sm-6 col-lg-3 g-3">
        <kpi-card
            title="Chef.fe de projets"
            [body]="{value: project?.leadUser?.lastname || 'Aucun'}"
            [footer]="{ prefix: 'Activité: ', value: project?.activity?.label}"
            [isLoading]="!project"
            class="h-100"></kpi-card>
    </div>

</div>
<br/>
<div class="row g-3">
    <div class="col-sm-2 offset-sm-10">
        <ed-button
            [colorSchema]="buttonColors.Secondary"
            (click)="addPhase()"
            [disabled]="!project"
        >
            Ajouter une phase
        </ed-button>
    </div> 
</div>
<br/>
<div class="row g-3">
    <div class="col-sm-12">
            <table-card 
                title="Phases"
                [isLoading]="!project" 
                [dataSource]="phasesData" 
                [displayedColumns]="phasesColumns"
                (onRowClick)="goToPhase($event)"
                [sortInfo]="{field: 'code', order: 1}"
                >
            </table-card>
    </div>
</div>

<br/>

<div class="row g-3">
    <div class="col-sm-12">
            <table-card 
                title="Principaux contributeurs"
                [isLoading]="!project" 
                [dataSource]="usersData" 
                [displayedColumns]="usersColumns"
                (onRowClick)="goToContributor($event)"
                [sortInfo]="{field: 'daysDeclared', order: -1}"
                >
            </table-card>
    </div>
</div>
